import React from 'react';
import { Box, Typography } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const PromoTicket = () => {
  // Get the current year dynamically
  const currentYear = new Date().getFullYear();
  
  // Extract the last two digits (e.g., "26" from 2026)
  const shortYear = currentYear.toString().slice(-2);
  
  // Construct the dynamic promo code
  const promoCode = `PROMO${shortYear}`;
  
  const handleCopy = () => {
    navigator.clipboard.writeText(promoCode);
    alert(`Code ${promoCode} copied to clipboard!`);
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          maxWidth: '400px',
          background: 'linear-gradient(135deg, #d32f2f 0%, #b71c1c 100%)', // Festive Red
          color: '#fff',
          borderRadius: '8px',
          p: 3,
          boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
          textAlign: 'center',
          border: '2px dashed rgba(255,255,255,0.3)', // Dashed border inside
          
          // The "Notches" (Cutouts) for the ticket look
          '&::before, &::after': {
            content: '""',
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            width: '20px',
            height: '20px',
            backgroundColor: '#fff', // Must match your page background color
            borderRadius: '50%',
          },
          '&::before': { left: '-10px' },
          '&::after': { right: '-10px' },
        }}
      >
        {/* Ticket Header */}
        <Typography variant="overline" sx={{ letterSpacing: 2, opacity: 0.8, fontWeight: 'bold' }}>
          LIMITED TIME OFFER
        </Typography>

        {/* Main Offer */}
        <Typography variant="h4" component="div" sx={{ fontWeight: '900', my: 1, textShadow: '1px 1px 2px rgba(0,0,0,0.3)' }}>
          FREE LISTING
        </Typography>

        <Typography variant="body2" sx={{ mb: 2 }}>
          {/* Dynamically display the full year here */}
          List your display on the {currentYear} Map for <strong>$0.00</strong>
        </Typography>

        {/* The Code Box */}
        <Box 
          sx={{ 
            background: '#fff', 
            color: '#d32f2f', 
            py: 1, 
            px: 2, 
            borderRadius: '4px', 
            display: 'inline-flex',
            alignItems: 'center',
            gap: 1,
            cursor: 'pointer',
            border: '2px dashed #d32f2f'
          }}
          onClick={handleCopy}
        >
          <Typography variant="h5" sx={{ fontWeight: 'bold', fontFamily: 'monospace' }}>
            {/* Display the dynamic promo code here */}
            {promoCode}
          </Typography>
          <ContentCopyIcon fontSize="small" />
        </Box>

        <Typography variant="caption" display="block" sx={{ mt: 1, opacity: 0.7 }}>
          Tap code to copy • Apply at checkout
        </Typography>

      </Box>
    </Box>
  );
};

export default PromoTicket;